module.exports = __webpack_public_path__ + "static/media/thirteen.bdd59cf6.svg";